import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../client';
import type { BookmarkDetail } from 'markcat-domain';
import { invalidateBookmarkData } from '../queries/useBookmarks';

interface CreateBookmarkInput {
  url: string;
  title?: string;
  source?: string;
}

export function useCreateBookmark() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateBookmarkInput) =>
      apiFetch<BookmarkDetail>('/api/bookmarks', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      invalidateBookmarkData(queryClient);
      queryClient.invalidateQueries({ queryKey: ['progress'] });
    },
  });
}
